import {
  TooltipProps as MuiTooltipProps,
  Typography,
  Tooltip as MuiTooltip,
  TypographyProps,
  styled,
} from '@mui/material';
import { FC, ReactNode } from 'react';

const CapitalizedTypography = styled(Typography)({ textTransform: 'capitalize' });

export type TooltipProps = MuiTooltipProps & {
  titleComponent?: ReactNode;
  variant?: TypographyProps['variant'];
};

export const Tooltip: FC<TooltipProps> = (props: TooltipProps) => {
  const { title, titleComponent, variant = 'p14', ...tooltipProps } = props;
  const finalTitle = titleComponent
    ? titleComponent
    : title && <CapitalizedTypography variant={variant}>{title}</CapitalizedTypography>;
  return (
    <MuiTooltip title={finalTitle} {...tooltipProps}>
      {props.children}
    </MuiTooltip>
  );
};
